import { AsideNav } from "./aside/AsideNav";
import { Header } from "./Header";
import AiChatWidget from "../../../../_metronic/layout/components/extras/ai-chat/AiChatWidget";

export const Layout = ({ children }) => {
    return (
        <div className="h-100 w-100 d-flex flex-column">
            <Header />
            <div className="d-flex w-100" style={{ height: "calc(100% - 52px)" }}>
                <AsideNav />
                <div className="col px-0 d-flex overflow-auto">
                    {children}
                </div>
            </div>
            {/* <WebsiteHealthWidget /> */}
            <AiChatWidget />
        </div>
    )
}
